import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { LANGUAGES } from '../../_i18n/languages';

const LANGUAGE_OPTIONS = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'pt', label: 'Português', flag: '🇧🇷' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' }
];

const Header = (props) => {
  const currentPath = props.location?.pathname || '/';
  const pathParts = currentPath.split('/').filter(Boolean);
  const localePath = pathParts[0];
  const hasLang = localePath && LANGUAGES[localePath] ? localePath : 'en';
  const langPrefix = `/${hasLang}`;
  const homeLink = hasLang === 'en' ? '/' : `/${hasLang}`;

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    if (newLang === hasLang) return;

    let restOfPath = '';
    if (pathParts.length > 0 && LANGUAGES[pathParts[0]]) {
      restOfPath = pathParts.slice(1).join('/');
    } else {
      restOfPath = pathParts.join('/');
    }

    const search = props.location?.search || '';
    let targetUrl = '';
    if (newLang === 'en') {
      targetUrl = restOfPath ? `/${restOfPath}` : '/';
    } else {
      targetUrl = restOfPath ? `/${newLang}/${restOfPath}` : `/${newLang}`;
    }

    const fullUrl = targetUrl + search;

    if (typeof window !== 'undefined') {
      window.location.href = fullUrl;
    } else if (props.history?.push) {
      props.history.push(fullUrl);
    }
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-dark fixed-top" style={{
        background: 'rgba(15, 23, 42, 0.95)',
        backdropFilter: 'blur(16px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)'
      }}>
        <div className="container">
          <Link to={homeLink} style={{ fontWeight: 700, color: '#f8fafc', textDecoration: 'none' }}>
            <img src="/logo32.png" alt="timenowin.net" className="logo" style={{ marginRight: '12px', borderRadius: '6px' }} />
            <span style={{ fontSize: '1.45rem', fontWeight: 800, letterSpacing: '-0.02em', color: '#f8fafc' }}>
              TimeNow<span style={{ color: '#38bdf8' }}>In</span>
            </span>
          </Link>

          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation" style={{ border: '1px solid rgba(255, 255, 255, 0.15)' }}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav ml-auto align-items-lg-center" style={{ gap: '6px' }}>
              <li className="nav-item">
                <Link className="nav-link" to={homeLink} style={{ color: '#cbd5e1', fontWeight: 500 }}>
                  <FormattedMessage id="header.navLink.currentTime" defaultMessage="World Clock" />
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={`${langPrefix}/time-difference/new-york-to-london`} style={{ color: '#cbd5e1', fontWeight: 500 }}>
                  <FormattedMessage id="header.navLink.timeDifference" defaultMessage="Time Difference" />
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={`${langPrefix}/countdown-timer`} style={{ color: '#cbd5e1', fontWeight: 500 }}>
                  <FormattedMessage id="header.navLink.countdownTimer" defaultMessage="Timer" />
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={`${langPrefix}/stopwatch`} style={{ color: '#cbd5e1', fontWeight: 500 }}>
                  <FormattedMessage id="header.navLink.stopwatch" defaultMessage="Stopwatch" />
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/blog" style={{ color: '#cbd5e1', fontWeight: 500 }}>
                  <FormattedMessage id="header.navLink.blog" defaultMessage="Blog" />
                </a>
              </li>
              <li className="nav-item d-flex align-items-center ml-lg-3 my-2 my-lg-0">
                <div className="header-lang-container">
                  <select
                    className="header-lang-select"
                    value={hasLang}
                    onChange={handleLanguageChange}
                    aria-label="Select Language"
                    title="Change Language"
                  >
                    {LANGUAGE_OPTIONS.map((lang) => (
                      <option key={lang.code} value={lang.code}>
                        {lang.flag} {lang.label}
                      </option>
                    ))}
                  </select>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default withRouter(Header);